:host{
    width: 100%;
    height: 100%;
    display: block;
}
.infinite-scroll-component {
    height: 100%;
    .content-wrapper {
        width: 100%;
        height: 100%;
        display: none;
        overflow: auto;
        &.--show {
            display: block;
        }

        ::slotted([slot="content"]) {
            height: auto;
        }

    }
    .loading-wrapper {
        display: none;
        .default-loading {
            width: 40px;
            height: 40px;
            margin: 0 auto;
        }

        &.--show {
            display: block;
        }
    }
    .empty-list-wrapper {
        width: 100%;
        height: 100%;
        display: none;

        &.--show {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        ::slotted([slot="empty"]){
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            max-height: 100%;
            overflow-y: hidden;
            background-color: transparent;
            padding: 1rem;
            box-sizing: border-box;
        }
    }

    
}